import { readSchema, type DatabaseSchema } from '@nexus/core';
import { loadDatabase, type LoadedDatabase } from '@nexus/workspace';
import { useStoreQuery } from './context';

/** A database (schema + rows); null when the page is not a database. */
export function useDatabase(pageId: string): LoadedDatabase | null | undefined {
  return useStoreQuery((s) => loadDatabase(s, pageId), [pageId], ['props', 'pages']);
}

/** All databases in the workspace, with their schema (for pickers). */
export function useDatabaseList():
  { id: string; title: string; schema: DatabaseSchema }[] | undefined {
  return useStoreQuery(
    async (s) =>
      (await s.listPagesWithProps())
        .map((p) => ({ id: p.id, title: p.title, schema: readSchema(p.props) }))
        .filter((d): d is { id: string; title: string; schema: DatabaseSchema } => !!d.schema),
    [],
    ['props', 'pages'],
  );
}
